module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [
    [_c('div', [_c('div', {
      staticClass: "home-content"
    }, [_c('div', {
      staticClass: "flex-content"
    }, [_c('div', {
      staticClass: "color-box bg-primary",
      on: {
        "click": function($event) {
          return _vm.toMyInventoryCustomer()
        }
      }
    }, [_c('div', {
      staticStyle: {
        "display": "flex",
        "align-items": "center",
        "justify-content": "space-between"
      }
    }, [_vm._m(0), _vm._v(" "), _c('div', [_c('h2', [_vm._v(_vm._s(_vm.homePageData.DtProducts))])])]), _vm._v(" "), _c('div', {
      staticClass: "card-text"
    }, [_vm._v("My products")])]), _vm._v(" "), _c('div', {
      staticClass: "color-box bg-warning",
      on: {
        "click": function($event) {
          return _vm.toOrderList()
        }
      }
    }, [_c('div', {
      staticStyle: {
        "display": "flex",
        "align-items": "center",
        "justify-content": "space-between"
      }
    }, [_vm._m(1), _vm._v(" "), _c('div', [_c('h2', [_vm._v(_vm._s(_vm.homePageData.DtOrders))])])]), _vm._v(" "), _c('div', {
      staticClass: "card-text"
    }, [_vm._v("Shipped Orders")])]), _vm._v(" "), _c('div', {
      staticClass: "color-box bg-success",
      on: {
        "click": _vm.toMyPaidDetail
      }
    }, [_c('div', {
      staticStyle: {
        "display": "flex",
        "align-items": "center",
        "justify-content": "space-between"
      }
    }, [_vm._m(2), _vm._v(" "), _c('div', [_c('h2', [_vm._v(_vm._s(_vm.Me && _vm.Me.Account ? _vm.Me.Account.realBalance + '(' + (_vm.Me.Account.Currency.EnName) + ')' : '0'))])])]), _vm._v(" "), _c('div', {
      staticClass: "card-text"
    }, [_vm._v("Account Balance")])]), _vm._v(" "), (_vm.showhelp == false) ? _c('div', {
      staticClass: "color-box bg-danger",
      on: {
        "click": _vm.toSupportTicket
      }
    }, [_c('div', {
      staticStyle: {
        "display": "flex",
        "align-items": "center",
        "justify-content": "space-between"
      }
    }, [_vm._m(3), _vm._v(" "), _c('div', [_c('h2', [_vm._v(_vm._s(_vm.Question && _vm.Question.Records ? _vm.Question.Records.length : '0'))])])]), _vm._v(" "), _c('div', {
      staticClass: "card-text"
    }, [_vm._v("Support Ticket")])]) : _c('div', {
      staticClass: "color-box bg-danger",
      on: {
        "click": _vm.toMyQusetion
      }
    }, [_c('div', {
      staticStyle: {
        "display": "flex",
        "align-items": "center",
        "justify-content": "space-between"
      }
    }, [_vm._m(4), _vm._v(" "), _c('div', [_c('h2', [_vm._v(_vm._s(_vm.Question && _vm.Question.Records ? _vm.Question.Records.length : '0'))])])]), _vm._v(" "), _c('div', {
      staticClass: "card-text"
    }, [_vm._v("Support Ticket")])])])])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "display": "flex",
        "justify-content": "space-around"
      }
    }, [_c('div', {
      staticClass: "card"
    }, [_c('div', {
      staticClass: "card-title",
      staticStyle: {
        "position": "relative",
        "font-weight": "bold",
        "font-size": "20px"
      }
    }, [_vm._v("Sales")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "display": "flex",
        "justify-content": "center"
      }
    }, [_c('div', {
      ref: "chart",
      staticStyle: {
        "width": "800px",
        "height": "480px"
      },
      attrs: {
        "id": "echarts1"
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "card"
    }, [_c('div', {
      staticClass: "card-title",
      staticStyle: {
        "position": "relative",
        "margin-bottom": "30px",
        "font-weight": "bold",
        "font-size": "20px"
      }
    }, [_vm._v("Products")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "display": "flex",
        "justify-content": "center"
      }
    }, [_c('div', {
      ref: "chart2",
      staticStyle: {
        "width": "600px",
        "height": "500px"
      },
      attrs: {
        "id": "echarts2"
      }
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "app-container",
      staticStyle: {
        "display": "none"
      }
    }, [_c('el-row', {
      attrs: {
        "gutter": 12
      }
    }, [_c('el-col', [_c('el-card', {
      staticClass: "box-card1"
    }, [_c('div', {
      staticClass: "clearfix",
      attrs: {
        "slot": "header"
      },
      slot: "header"
    }, [_c('span', {
      staticStyle: {
        "font-size": "18px"
      }
    }, [_c('i', {
      staticClass: "el-icon-bell",
      staticStyle: {
        "margin-right": "10px",
        "color": "#409EFF",
        "font-size": "19px"
      }
    }), _vm._v(_vm._s(_vm.g('$新闻/公告')))]), _vm._v(" "), _c('el-button', {
      staticStyle: {
        "float": "right",
        "padding": "3px 0"
      },
      attrs: {
        "type": "text"
      },
      on: {
        "click": function($event) {
          return _vm.toSearchSys_New()
        }
      }
    }, [_vm._v(_vm._s(_vm.g('$刷新')))])], 1), _vm._v(" "), _vm._l((_vm.SearchSys_New), function(o) {
      return _c('div', {
        key: o.ID,
        staticClass: "text item clearfix"
      }, [_c('a', {
        staticStyle: {
          "float": "left"
        },
        on: {
          "click": function($event) {
            return _vm.ToNew(o.ID)
          }
        }
      }, [_c('span', {
        staticClass: "dot"
      }), _vm._v(" " + _vm._s(o.Title))]), _vm._v(" "), _c('span', {
        staticStyle: {
          "float": "right"
        }
      }, [_vm._v(_vm._s(o.OperatorTime))])])
    })], 2)], 1)], 1)], 1)]
  ], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('i', {
    staticClass: "el-icon-collection",
    staticStyle: {
      "font-size": "40px"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('i', {
    staticClass: "el-icon-document-checked",
    staticStyle: {
      "font-size": "40px"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('i', {
    staticClass: "el-icon-money",
    staticStyle: {
      "font-size": "40px"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('i', {
    staticClass: "el-icon-service",
    staticStyle: {
      "font-size": "40px"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('i', {
    staticClass: "el-icon-service",
    staticStyle: {
      "font-size": "40px"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-43d47edf"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/frame/Order/StoreAnalysis.vue
// module id = 1282
// module chunks = 169